export default __webpack_public_path__ + "static/media/chopy_l.afac3a15.jpg";